import React from "react";
import { Grid, Row, Col } from "@govlaunch/core";
import { IVendorUser } from "~/types/types";
import UpgradeToMakersProBanner from "~/components/vendor/profile/UpgradeToMakersProBanner";

interface IVendorUpgradeRequiredProps {
  user: IVendorUser;
}

export default function VendorUpgradeRequired({ user }: IVendorUpgradeRequiredProps) {
  if (!user.company) {
    return null;
  }

  return (
    <Grid>
      <Row mb={[20, 20, 20, 20]}>
        <Col width={[1, 1, 1, 1]}>
          <UpgradeToMakersProBanner />
        </Col>
      </Row>
    </Grid>
  );
}
